"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.array.find");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.array.sort");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _decorateConfigItem = require("@/api/decorate/decorateConfigItem.js");
var _decorateConfig = require("@/api/decorate/decorateConfig.js");
var _popupConfig = require("@/api/popup/popupConfig.js");
var _memberManagement = require("@/api/member/memberManagement.js");
var _popupTypes = require("@/utils/popupTypes.js");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ResourceNiche',
  props: {
    pageKey: {
      type: String,
      default: ''
    },
    moduleKey: {
      type: String,
      default: ''
    },
    xcxType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      titleName: '',
      imagePrefix: '',
      currentImageIndex: -1,
      nicheList: [],
      selectedNiches: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '添加资源位',
      isEdit: false,
      currentId: null,
      pageList: [],
      surveyOptions: [],
      // 门店相关数据
      storeSearchText: '',
      // 门店搜索文本
      storeTreeData: [],
      // 树状门店数据
      defaultProps: {
        // 树形控件属性
        children: 'children',
        label: 'label'
      },
      expandedKeys: [],
      // 默认展开的节点
      checkedKeys: [],
      // 默认选中的节点
      totalShops: 0,
      // 总门店数
      selectedShopsCount: 0,
      // 已选门店数
      // 预览相关
      previewVisible: false,
      allPage: [],
      previewImageUrl: '',
      qrCodeDialogVisible: false,
      qrCodeImage: '',
      formData: {
        title: '',
        recommendType: 1,
        startTime: '',
        endTime: '',
        sort: 1,
        visible: true,
        imageUrl: '',
        recommendContent: '',
        recommendContentSub: null,
        recommendContentId: null,
        recommendContentParam: null,
        selectedStores: [],
        // 选中的门店ID数组
        isPermanent: true // 是否永久有效
      },
      rules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        recommendType: [{
          required: true,
          message: '请选择推荐类型',
          trigger: 'change'
        }],
        sort: [{
          required: true,
          message: '请输入排序',
          trigger: 'change'
        }],
        startTime: [{
          required: true,
          message: '请选择开始时间',
          trigger: 'change'
        }],
        endTime: [{
          required: true,
          message: '请选择结束时间',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    // 将推荐类型与目标映射为展示文案
    recommendTypeMap: function recommendTypeMap() {
      return {
        system: '系统页面',
        custom: '自定义链接'
      };
    }
  },
  watch: {
    storeSearchText: function storeSearchText(val) {
      this.$refs.storeTree.filter(val);
    }
  },
  created: function created() {
    // 页面加载时获取已保存的配置
    this.loadConfig();
    // 获取图片前缀
    this.getImagePrefix();
    // 获取页面列表
    this.getPageList();
    // 获取门店列表
    this.getShopList();
  },
  methods: {
    // 确认保存
    confirmSave: function confirmSave() {
      var _this = this;
      this.$confirm('保存后将替换正在使用的配置，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 用户点击确定，执行保存操作
        _this.handleSave();
      }).catch(function () {
        // 用户点击取消，不执行任何操作
        _this.$message.info('已取消保存');
      });
    },
    // 获取门店列表
    getShopList: function () {
      var _getShopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _popupConfig.getShops)();
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.data) {
                // 转换数据结构以匹配前端期望的格式
                this.storeTreeData = this.transformShopData(response.data);
                // 设置默认展开的节点为所有顶级节点
                this.expandedKeys = this.storeTreeData.map(function (item) {
                  return item.nodeKey;
                });
              } else {
                this.$message.error('获取门店列表失败');
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取门店列表错误：', _t);
              this.$message.error('获取门店列表失败');
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getShopList() {
        return _getShopList.apply(this, arguments);
      }
      return getShopList;
    }(),
    // 转换门店数据结构
    transformShopData: function transformShopData(data) {
      // 后端数据里区域id可能与门店storeId撞号、同一门店可能出现在多个区域下，
      // 直接用 id 作为 node-key 会因 key 重复导致 setCheckedKeys 勾选不上部分门店，
      // 因此用 nodeKey 保证唯一（区域 'r'+id、门店 's'+storeId），并对重复门店/区域去重
      var seenRegionIds = new Set();
      var seenStoreIds = new Set();
      var result = [];
      data.forEach(function (region) {
        if (seenRegionIds.has(region.id)) return;
        seenRegionIds.add(region.id);
        // 复制区域信息
        var transformedRegion = {
          id: region.id,
          nodeKey: 'r' + region.id,
          isRegion: true,
          label: region.label,
          children: []
        };

        // 转换子节点（门店），同一门店只保留第一次出现
        if (region.children && region.children.length > 0) {
          region.children.forEach(function (shop) {
            if (seenStoreIds.has(shop.storeId)) return;
            seenStoreIds.add(shop.storeId);
            transformedRegion.children.push({
              id: shop.storeId,
              // 使用storeId作为id
              nodeKey: 's' + shop.storeId,
              label: shop.shopName,
              // 使用shopName作为label
              regId: shop.regId,
              regName: shop.regName
            });
          });
        }
        result.push(transformedRegion);
      });
      return result;
    },
    // 获取页面列表
    getPageList: function () {
      var _getPageList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.data) {
                this.allPage = response.data.map(function (item) {
                  return {
                    value: item.pageUrl,
                    label: item.pageName,
                    appid: item.appid,
                    id: String(item.id)
                  };
                });
                this.pageList = this.allPage;
                if (this.formData.recommendType == 3) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAX' || item.appid === 'DELI';
                  });
                } else if (this.formData.recommendType == 6) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAS';
                  });
                }
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取页面列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getPageList() {
        return _getPageList.apply(this, arguments);
      }
      return getPageList;
    }(),
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.loadConfig();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadConfig();
    },
    // 添加资源位
    handleAdd: function handleAdd() {
      this.dialogTitle = '添加资源位';
      this.isEdit = false;
      this.dialogVisible = true;
      this.resetForm();
    },
    // 编辑资源位
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(row) {
        var loadingInstance, response, detailData, extraData, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingInstance = null;
              _context3.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置项详情
              _context3.next = 2;
              return (0, _decorateConfigItem.getConfigItemDetail)(row.id);
            case 2:
              response = _context3.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 解析详情数据
                detailData = response.data;
                extraData = detailData.extra ? JSON.parse(detailData.extra) : {};
                this.dialogTitle = '编辑资源位';
                this.isEdit = true;
                this.currentId = detailData.id;
                this.dialogVisible = true;

                // 填充表单数据
                this.formData = {
                  title: extraData.title || '',
                  recommendType: extraData.recommendType || 1,
                  startTime: extraData.startTime || '',
                  endTime: extraData.endTime || '',
                  sort: extraData.sort !== undefined ? extraData.sort : 1,
                  visible: extraData.visible !== undefined ? extraData.visible : true,
                  imageUrl: extraData.imageUrl || '',
                  recommendContent: extraData.recommendContent || '',
                  recommendContentId: extraData.recommendContentId != null ? String(extraData.recommendContentId) : null,
                  recommendContentParam: extraData.recommendContentParam || null,
                  selectedStores: extraData.selectedStores || [],
                  // 选中的门店ID数组
                  recommendContentSub: extraData.recommendContentSub || '',
                  // 子路径
                  isPermanent: extraData.isPermanent !== undefined ? extraData.isPermanent : true
                };
                if (this.formData.recommendType == 3) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAX' || item.appid === 'DELI';
                  });
                } else if (this.formData.recommendType == 6) {
                  this.pageList = this.allPage.filter(function (item) {
                    return item.appid === 'GAGAS';
                  });
                }

                // 更新选中门店数
                this.selectedShopsCount = this.formData.selectedStores.length;

                // 初始化选中的门店 - 确保门店数据已加载后再设置选中状态
                this.setCheckedKeysAfterShopDataLoaded();
              } else {
                this.$message.error(response.message || '加载详情失败!');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('加载详情失败:', _t3);
              this.$message.error('加载详情失败: ' + (_t3.message || '未知错误'));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleEdit(_x) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 在门店数据加载完成后设置选中状态
    setCheckedKeysAfterShopDataLoaded: function setCheckedKeysAfterShopDataLoaded() {
      var _this2 = this;
      return new Promise(function (resolve) {
        // 如果门店数据已经加载完成，直接设置选中状态
        if (_this2.storeTreeData && _this2.storeTreeData.length > 0) {
          _this2.setCheckedKeys();
          resolve();
        } else {
          // 如果门店数据还未加载完成，等待数据加载完成后再设置
          var unwatch = _this2.$watch('storeTreeData', function (newVal) {
            if (newVal && newVal.length > 0) {
              _this2.$nextTick(function () {
                _this2.setCheckedKeys();
                unwatch(); // 取消监听
                resolve();
              });
            }
          });
        }
      });
    },
    // 设置选中的门店keys
    setCheckedKeys: function setCheckedKeys() {
      if (this.formData.selectedStores && this.formData.selectedStores.length > 0) {
        // 确保门店ID是数字类型，并转换为树的nodeKey（'s'+storeId）
        var checkedKeys = this.formData.selectedStores.map(function (id) {
          return 's' + parseInt(id);
        });
        this.checkedKeys = checkedKeys;
        if (this.$refs.storeTree) {
          this.$refs.storeTree.setCheckedKeys(checkedKeys);
        }
      } else {
        // 没有选中的门店，清空选中状态
        this.checkedKeys = [];
        if (this.$refs.storeTree) {
          this.$refs.storeTree.setCheckedKeys([]);
        }
      }
    },
    // 移除资源位
    handleRemove: function handleRemove(row) {
      var _this3 = this;
      this.$confirm('确定要移除该资源位吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _decorateConfigItem.deleteConfigItem)(row.id);
            case 1:
              response = _context4.sent;
              if (!(response.code === 200)) {
                _context4.next = 3;
                break;
              }
              _context4.next = 2;
              return _this3.loadConfig();
            case 2:
              _this3.$message.success('移除成功');
              _context4.next = 4;
              break;
            case 3:
              _this3.$message.error(response.message || '删除失败!');
            case 4:
              _context4.next = 6;
              break;
            case 5:
              _context4.prev = 5;
              _t4 = _context4["catch"](0);
              console.error('删除失败:', _t4);
              _this3.$message.error('删除失败: ' + (_t4.message || '未知错误'));
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 5]]);
      }))).catch(function () {
        _this3.$message.info('已取消移除');
      });
    },
    // 切换显示状态
    handleToggleVisible: function () {
      var _handleToggleVisible = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(row) {
        var response, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _decorateConfigItem.enableConfigItem)(row.id);
            case 1:
              response = _context5.sent;
              if (!(response.code === 200)) {
                _context5.next = 3;
                break;
              }
              _context5.next = 2;
              return this.loadConfig();
            case 2:
              this.$message.success("\u66F4\u65B0\u6210\u529F");
              _context5.next = 4;
              break;
            case 3:
              // 如果接口调用失败，恢复开关状态
              row.visible = !row.visible;
              this.$message.error(response.message || '操作失败!');
            case 4:
              _context5.next = 6;
              break;
            case 5:
              _context5.prev = 5;
              _t5 = _context5["catch"](0);
              // 如果接口调用失败，恢复开关状态
              row.visible = !row.visible;
              console.error('操作失败:', _t5);
              this.$message.error('操作失败: ' + (_t5.message || '未知错误'));
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 5]]);
      }));
      function handleToggleVisible(_x2) {
        return _handleToggleVisible.apply(this, arguments);
      }
      return handleToggleVisible;
    }(),
    // 提交表单
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this4 = this;
        return regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.$refs.form.validate(/*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(valid) {
                  var loadingInstance, data, response, _t6;
                  return regeneratorRuntime.wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        if (valid) {
                          _context6.next = 1;
                          break;
                        }
                        return _context6.abrupt("return");
                      case 1:
                        loadingInstance = null;
                        _context6.prev = 2;
                        _context6.next = 3;
                        return _this4.setCheckedKeysAfterShopDataLoaded();
                      case 3:
                        // 社区模式：清理"其他"模式遗留的appid（recommendContentId 必须是选中的页面ID）
                        if (_this4.formData.recommendType == 6 && _this4.formData.recommendContentSub == 'GAGAS') {
                          if (!_this4.pageList.some(function (p) {
                            return p.id === _this4.formData.recommendContentId;
                          })) {
                            _this4.formData.recommendContentId = '';
                          }
                          _this4.formData.recommendContent = '';
                        }
                        data = {
                          id: _this4.isEdit ? _this4.currentId : null,
                          pageCode: _this4.pageKey,
                          optionCode: _this4.moduleKey,
                          title: _this4.formData.title,
                          enable: _this4.formData.visible,
                          extra: JSON.stringify({
                            title: _this4.formData.title,
                            recommendType: _this4.formData.recommendType,
                            startTime: _this4.formData.startTime,
                            endTime: _this4.formData.endTime,
                            sort: _this4.formData.sort,
                            visible: _this4.formData.visible,
                            imageUrl: _this4.formData.imageUrl,
                            recommendContent: _this4.formData.recommendContent,
                            recommendContentId: _this4.formData.recommendContentId,
                            recommendContentParam: _this4.formData.recommendContentParam,
                            selectedStores: _this4.formData.selectedStores,
                            // 保存选中的门店ID数组
                            isPermanent: _this4.formData.isPermanent,
                            // 是否永久有效
                            recommendContentSub: _this4.formData.recommendContentSub // 子路径
                          })
                        }; // 显示保存loading状态
                        loadingInstance = _this4.$loading({
                          lock: true,
                          text: '保存中...',
                          spinner: 'el-icon-loading',
                          background: 'rgba(0, 0, 0, 0.7)'
                        });

                        // 调用后端接口保存配置
                        _context6.next = 4;
                        return (0, _decorateConfigItem.saveConfigItem)(data);
                      case 4:
                        response = _context6.sent;
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        if (!(response.code === 200)) {
                          _context6.next = 6;
                          break;
                        }
                        // 保存成功后关闭对话框
                        _this4.dialogVisible = false;
                        // 刷新列表数据
                        _context6.next = 5;
                        return _this4.loadConfig();
                      case 5:
                        _this4.$message.success(_this4.isEdit ? '编辑成功' : '添加成功');
                        _context6.next = 7;
                        break;
                      case 6:
                        _this4.$message.error(response.message || '保存失败!');
                      case 7:
                        _context6.next = 9;
                        break;
                      case 8:
                        _context6.prev = 8;
                        _t6 = _context6["catch"](2);
                        // 关闭loading
                        if (loadingInstance) {
                          loadingInstance.close();
                        }
                        console.error('保存失败:', _t6);
                        _this4.$message.error('保存失败: ' + (_t6.message || '未知错误'));
                      case 9:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6, null, [[2, 8]]);
                }));
                return function (_x3) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 重置表单
    resetForm: function resetForm() {
      this.currentId = null;
      this.formData = {
        title: '',
        recommendType: 1,
        startTime: '',
        endTime: '',
        sort: 1,
        visible: true,
        imageUrl: '',
        recommendContent: '',
        recommendContentSub: null,
        recommendContentId: null,
        recommendContentParam: null,
        selectedStores: [] // 重置选中的门店ID数组
      };
      if (this.$refs.form) this.$refs.form.clearValidate();

      // 清空门店选择
      this.checkedKeys = [];
      if (this.$refs.storeTree) {
        this.$refs.storeTree.setCheckedKeys([]);
      }

      // 重置门店统计
      this.selectedShopsCount = 0;
    },
    // 获取图片前缀
    getImagePrefix: function () {
      var _getImagePrefix2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response, _t7;
        return regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return (0, _memberManagement.getImagePrefix)();
            case 1:
              response = _context8.sent;
              if (response.code === 200 && response.data) {
                this.imagePrefix = response.data;
              }
              _context8.next = 3;
              break;
            case 2:
              _context8.prev = 2;
              _t7 = _context8["catch"](0);
              console.error('获取图片前缀失败:', _t7);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[0, 2]]);
      }));
      function getImagePrefix() {
        return _getImagePrefix2.apply(this, arguments);
      }
      return getImagePrefix;
    }(),
    // 获取图片完整URL
    getImageUrl: function getImageUrl(url) {
      // 如果没有url则返回空
      if (!url) return '';

      // 如果已经是完整URL则直接返回
      if (url.startsWith('http')) {
        return url;
      }

      // 如果有图片前缀，使用图片前缀
      if (this.imagePrefix) {
        // 确保前缀末尾没有斜杠，url开头有斜杠
        var prefix = this.imagePrefix.endsWith('/') ? this.imagePrefix.slice(0, -1) : this.imagePrefix;
        var path = url.startsWith('/') ? url : '/' + url;
        return prefix + path;
      }

      // 如果是相对路径，则加上基础URL
      return process.env.VUE_APP_BASE_API + url;
    },
    // 点击图片预览区域
    handleImageClick: function handleImageClick() {
      this.$refs.fileInput.click();
    },
    // 文件选择变化
    handleFileChange: function handleFileChange(event) {
      var files = event.target.files;
      if (files.length === 0) return;
      var file = files[0];
      if (this.validateImage(file)) {
        this.uploadImage(file);
      }

      // 清空input值，允许重复选择同一文件
      event.target.value = '';
    },
    // 验证图片文件
    validateImage: function validateImage(file) {
      var isImage = file.type.startsWith('image/');
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB!');
        return false;
      }
      return true;
    },
    // 上传图片
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(file) {
        var _loading, response, imageUrl, _t8;
        return regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              // 显示上传loading状态
              _loading = this.$loading({
                lock: true,
                text: '图片上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              }); // 调用后端接口上传图片
              _context9.next = 1;
              return (0, _popupConfig.uploadPopupImage)(file);
            case 1:
              response = _context9.sent;
              // 关闭loading
              _loading.close();
              if (response.code === 200) {
                imageUrl = response.data;
                this.formData.imageUrl = imageUrl;
                this.$message.success('图片上传成功!');
              } else {
                this.$message.error(response.message || '图片上传失败!');
              }
              _context9.next = 3;
              break;
            case 2:
              _context9.prev = 2;
              _t8 = _context9["catch"](0);
              // 关闭loading
              if (loading) {
                loading.close();
              }
              console.error('图片上传失败:', _t8);
              this.$message.error('图片上传失败: ' + (_t8.message || '未知错误'));
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0, 2]]);
      }));
      function uploadImage(_x4) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    // 加载配置
    loadConfig: function () {
      var _loadConfig = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee0() {
        var loadingInstance, response, _t9;
        return regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              loadingInstance = null;
              _context0.prev = 1;
              if (!(!this.pageKey || !this.moduleKey)) {
                _context0.next = 2;
                break;
              }
              return _context0.abrupt("return");
            case 2:
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '加载配置中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口获取配置
              _context0.next = 3;
              return (0, _decorateConfigItem.getDecorateConfigItem)(this.pageKey, this.moduleKey, this.currentPage, this.pageSize, this.titleName);
            case 3:
              response = _context0.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.records) {
                // 解析配置信息
                this.nicheList = response.records.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    extra: item.extra ? JSON.parse(item.extra) : {},
                    // 兼容旧数据结构
                    title: item.title,
                    recommendType: item.extra ? JSON.parse(item.extra).recommendType : 1,
                    startTime: item.extra ? JSON.parse(item.extra).startTime : '',
                    endTime: item.extra ? JSON.parse(item.extra).endTime : '',
                    sort: item.extra ? JSON.parse(item.extra).sort : 1,
                    visible: item.enable !== undefined ? item.enable : true,
                    recommendContent: item.extra ? JSON.parse(item.extra).recommendContent : '',
                    recommendContentId: item.extra ? JSON.parse(item.extra).recommendContentId : null,
                    recommendContentParam: item.extra ? JSON.parse(item.extra).recommendContentParam : null,
                    selectedStores: item.extra ? JSON.parse(item.extra).selectedStores : [] // 选中的门店ID数组
                  });
                });
                this.total = response.total;
                this.pageSize = response.size;
              } else if (response.code !== 200) {
                this.$message.error(response.message || '配置加载失败!');
              }
              _context0.next = 5;
              break;
            case 4:
              _context0.prev = 4;
              _t9 = _context0["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('配置加载失败:', _t9);
              this.$message.error('配置加载失败: ' + (_t9.message || '未知错误'));
            case 5:
            case "end":
              return _context0.stop();
          }
        }, _callee0, this, [[1, 4]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    // 保存配置（保留原有功能）
    handleSave: function () {
      var _handleSave = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee1() {
        return regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              _context1.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('资源位配置保存成功');
            case 2:
            case "end":
              return _context1.stop();
          }
        }, _callee1, this);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }(),
    // 预览配置（保留原有功能）
    handlePreview: function handlePreview() {
      var config = {
        resources: this.nicheList
      };
      console.log('预览资源位配置:', config);
      this.$message.info('预览功能开发中...');
    },
    // 应用配置（保留原有功能）
    handleApply: function () {
      var _handleApply = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 1;
              return this.loadConfig();
            case 1:
              this.$message.success('资源位配置应用成功');
            case 2:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleApply() {
        return _handleApply.apply(this, arguments);
      }
      return handleApply;
    }(),
    // 获取类型标签样式
    getTypeTagType: function getTypeTagType(recommendType) {
      return _popupTypes.RecommendTypeTagMap[recommendType] || '';
    },
    // 获取类型文本
    getTypeText: function getTypeText(recommendType) {
      return _popupTypes.RecommendTypeTextMap[recommendType] || '未知类型';
    },
    // 获取推荐内容
    getRecommendContent: function getRecommendContent(row) {
      // 根据推荐类型返回对应的内容
      var content = '';
      var type = row.recommendType;
      var sub = row.extra && row.extra.recommendContentSub || '';
      var contentId = row.recommendContentId != null ? String(row.recommendContentId) : '';
      if (type === 3 || type === 4 || type === 8 || type === 6 && sub === 'GAGAS') {
        // 选页面类型：recommendContentId 为页面ID
        var page = this.allPage.find(function (p) {
          return p.id === contentId;
        });
        content = page ? page.label : contentId;
      } else if (type === 6) {
        // 外部小程序-其他：recommendContent 为appid，recommendContentId 为跳转地址
        if (contentId !== '') {
          content = (row.recommendContent || '') + '/' + contentId;
        } else {
          content = row.recommendContent || '';
        }
      } else if (type === 5 || type === 7) {
        // 问卷/红包封面：recommendContentId 为URL
        content = contentId || row.recommendContent || '';
      } else {
        content = row.recommendContent || '';
      }
      // 拼接参数
      if (content && row.recommendContentParam != null && row.recommendContentParam !== '') {
        content += '?' + row.recommendContentParam;
      }
      return content;
    },
    // 外部小程序类型(社区/其他)切换时清空后续输入框
    changeRecommendContentSub: function changeRecommendContentSub() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = null;
      this.formData.recommendContentParam = null;
    },
    // 推荐类型切换
    changeRecommendInfo: function changeRecommendInfo() {
      this.formData.recommendContent = '';
      this.formData.recommendContentId = null;
      this.formData.recommendContentParam = null;
      if (this.formData.recommendType == 3) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAX' || item.appid === 'DELI';
        });
      } else if (this.formData.recommendType == 6) {
        this.pageList = this.allPage.filter(function (item) {
          return item.appid === 'GAGAS';
        });
      }
    },
    // 处理门店选择变化
    handleStoreCheck: function handleStoreCheck(data, checked) {
      // 获取当前选中的门店
      var checkedNodes = this.$refs.storeTree.getCheckedNodes();
      // 只获取门店节点（排除区域节点，避免空区域被当成门店）
      var selectedStores = checkedNodes.filter(function (node) {
        return !node.isRegion;
      });
      // 保存选中的门店ID数组
      this.formData.selectedStores = selectedStores.map(function (store) {
        return store.id;
      });
      // 更新选中门店数
      this.selectedShopsCount = this.formData.selectedStores.length;
      console.log('已选择门店ID:', this.formData.selectedStores);
    },
    // 选择全部门店
    selectAllStores: function selectAllStores() {
      // 获取所有门店节点（非区域）的nodeKey
      var _getAllLeafKeys = function getAllLeafKeys(nodes) {
        var keys = [];
        nodes.forEach(function (node) {
          if (node.isRegion) {
            keys = keys.concat(_getAllLeafKeys(node.children || []));
          } else {
            keys.push(node.nodeKey);
          }
        });
        return keys;
      };
      var allLeafKeys = _getAllLeafKeys(this.storeTreeData);
      var currentCheckedKeys = this.$refs.storeTree.getCheckedKeys();

      // 检查当前是否已全选（包含叶子节点和部分父节点）
      var isAllSelected = allLeafKeys.every(function (key) {
        return currentCheckedKeys.includes(key);
      });
      if (isAllSelected) {
        // 如果已经全选，则取消全选
        this.$refs.storeTree.setCheckedKeys([]);
        this.formData.selectedStores = [];
        this.selectedShopsCount = 0;
        this.$message.info('已取消全选');
      } else {
        // 否则全选
        this.$refs.storeTree.setCheckedKeys(allLeafKeys);
        // 保存选中的门店ID数组（nodeKey去掉前缀's'还原为原始storeId）
        this.formData.selectedStores = allLeafKeys.map(function (key) {
          return parseInt(key.slice(1));
        });
        this.selectedShopsCount = allLeafKeys.length;
        this.$message.success("\u5DF2\u9009\u4E2D ".concat(allLeafKeys.length, " \u4E2A\u95E8\u5E97"));
      }
    },
    // 过滤节点
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 处理表格选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedNiches = selection;
    },
    // 预览功能
    preview: function () {
      var _preview = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var loadingInstance, ids, previewData, response, _t0;
        return regeneratorRuntime.wrap(function (_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(this.selectedNiches.length === 0)) {
                _context11.next = 1;
                break;
              }
              this.$message.warning('请至少选择一条数据进行预览');
              return _context11.abrupt("return");
            case 1:
              loadingInstance = null;
              _context11.prev = 2;
              // 获取选中数据的ID
              ids = this.selectedNiches.map(function (item) {
                return item.id;
              }); // 构造预览参数
              previewData = {
                ids: ids,
                pageCode: this.pageKey,
                optionCode: this.moduleKey,
                xcxType: this.xcxType,
                pageURl: "" // 设置默认页面URL，可根据实际需求调整
              }; // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '预览生成中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用预览接口
              _context11.next = 3;
              return (0, _decorateConfig.previewAdd)(previewData);
            case 3:
              response = _context11.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200) {
                // 预览成功，显示返回的图片
                if (response.data) {
                  // 检查是否有二维码URL直接返回
                  if (response.data.image && typeof response.data.image === 'string') {
                    // 如果返回了二维码URL，显示预览弹窗
                    this.previewImageUrl = response.data.image;
                    this.previewVisible = true;
                  } else {
                    this.$message.success('预览二维码生成成功');
                  }
                } else {
                  this.$message.success('预览二维码生成成功');
                }
              } else {
                this.$message.error(response.message || '预览失败!');
              }
              _context11.next = 5;
              break;
            case 4:
              _context11.prev = 4;
              _t0 = _context11["catch"](2);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('预览失败:', _t0);
              this.$message.error('预览失败: ' + (_t0.message || '未知错误'));
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this, [[2, 4]]);
      }));
      function preview() {
        return _preview.apply(this, arguments);
      }
      return preview;
    }(),
    // 处理预览弹窗关闭
    handlePreviewClose: function handlePreviewClose() {
      this.previewVisible = false;
      // 释放图片URL对象
      if (this.previewImageUrl) {
        URL.revokeObjectURL(this.previewImageUrl);
        this.previewImageUrl = '';
      }
    },
    // 生成二维码
    handleGenerateQrCode: function () {
      var _handleGenerateQrCode = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(row) {
        var loadingInstance, response, _t1;
        return regeneratorRuntime.wrap(function (_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              loadingInstance = null;
              _context12.prev = 1;
              // 显示加载loading状态
              loadingInstance = this.$loading({
                lock: true,
                text: '生成二维码中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用后端接口生成二维码
              _context12.next = 2;
              return generateQrCode(row.id);
            case 2:
              response = _context12.sent;
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              if (response.code === 200 && response.data) {
                // 显示二维码对话框
                this.qrCodeImage = response.data.image; // 假设后端直接返回图片URL
                this.qrCodeDialogVisible = true;
              } else {
                this.$message.error(response.message || '生成二维码失败!');
              }
              _context12.next = 4;
              break;
            case 3:
              _context12.prev = 3;
              _t1 = _context12["catch"](1);
              // 关闭loading
              if (loadingInstance) {
                loadingInstance.close();
              }
              console.error('生成二维码失败:', _t1);
              this.$message.error('生成二维码失败: ' + (_t1.message || '未知错误'));
            case 4:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this, [[1, 3]]);
      }));
      function handleGenerateQrCode(_x5) {
        return _handleGenerateQrCode.apply(this, arguments);
      }
      return handleGenerateQrCode;
    }()
  },
  mounted: function mounted() {
    // 移除原来的模拟数据处理逻辑，因为现在从接口获取数据
  },
  // 组件销毁前释放资源
  beforeDestroy: function beforeDestroy() {
    // 释放图片URL对象
    if (this.previewImageUrl) {
      URL.revokeObjectURL(this.previewImageUrl);
      this.previewImageUrl = '';
    }
    if (this.qrCodeImage) {
      URL.revokeObjectURL(this.qrCodeImage);
      this.qrCodeImage = '';
    }
  }
};